// @ts-strict

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @ngModule SharedModule
 * @description
 *
 * Looks up array for the value (eg. binded with ngModel to input)
 *
 * @usageNotes
 *
 * Usage:
 *   array | search:ngModelValue:parameter
 * Example:
 *   {{ valuesArray | search:search:'question' }}
 */
@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  transform(array: any[], searchValue: string, parameter: string | string[], alternativeArray?: any[], alternativeParameter?: string | string[]): any {
    if (!searchValue) {
      return array;
    }

    searchValue = searchValue.toLowerCase();

    if (alternativeArray && searchValue) {
      return alternativeArray.filter(item => {
        if (typeof alternativeParameter === 'string') {
          if (!item[alternativeParameter]) return false;

          return item[alternativeParameter].toString().toLowerCase().includes(searchValue);
        }

        if (alternativeParameter) {
          return !!alternativeParameter.find(param => item[param].toString().toLowerCase().includes(searchValue));
        }
      });
    }

    return array.filter(item => {
      if (typeof parameter === 'string') {
        if (!item[parameter]) return false;

        return item[parameter].toString().toLowerCase().includes(searchValue);
      }

      return !!parameter.find(param => {
        if (!item[param]) return undefined;

        return item[param].toString().toLowerCase().includes(searchValue);
      });
    });
  }
}
